import React, { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AlarmIcon from '@mui/icons-material/Alarm';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styled } from '@mui/material/styles';
import { Link, useParams } from 'react-router-dom';
import { useFetchEvent } from '../../hooks/fetch-event';
import { useAuth } from '../../hooks/useAuth';
import User from '../user/user';
import { Button } from '@mui/material';
import { placeBet, setResults } from '../../services/event-services';
import { toast } from 'react-toastify';
import { CssTextField } from '../layout/elements';
import CountryWithFlag from "./country";

const Container = styled('div')({
  textAlign: 'center'
});

const BetsList = styled('div')({
  display: 'grid',
  gridTemplateColumns: '2fr 1fr 1fr',
  margin: '5px 0 0 0'
});

const BackLink = styled(Link)({
  float: 'left',
  clear: 'both'
});

const AccentText = styled('p')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '20px'
}));

const NumberField = styled(CssTextField)({
  width: '120px'
});

export default function Event() {

  const { authData } = useAuth();
  const { id } = useParams()
  const [data, loading, error] = useFetchEvent(authData.token, id);
  const [event, setEvent] = useState(null);
  const [evtTime, setEvtTime] = useState(null);
  const [isFuture, setIsFuture] = useState(null);
  const [timeDiff, setTimeDiff] = useState(null);
  const [score1, setScore1] = useState(null);
  const [score2, setScore2] = useState(null);

  useEffect(() => {
    setEvent(data);
    if (data?.time) {
      const format = "yyyy-MM-dd'T'HH:mm:ss'Z'";
      const parsedUtcTime = DateTime.fromFormat(data.time, format, { zone: 'utc' });
      const localTime = parsedUtcTime.toLocal();
      setEvtTime(localTime);
      const now = DateTime.now();
      setIsFuture(localTime > now);
      setTimeDiff(parsedUtcTime.toRelative());
    }
  }, [data])

  const sendBet = async () => {
    const bet = await placeBet(authData.token, { score1, score2, 'event': event.id });
    if (bet) {
      if (bet.new) {
        event.bets.push(bet.result)
      } else {
        const myBetIndex = event.bets.findIndex(el => el.user.id === bet.result.user.id);
        event.bets[myBetIndex] = bet.result;
      }
      toast.success(bet.message);
      setScore1('');
      setScore2('');
    }
  }
  const setScores = async () => {
    const eventData = await setResults(authData.token, { score1, score2, 'event': event.id });
    if (eventData) {
      setEvent(eventData);
      toast.success("Scores has been set");
      setScore1('');
      setScore2('');
    } else {
      toast.error("Scores could not be set");
    }
  }

  if (error) return <h1>Error</h1>
  if (loading) return <h1>Loading....</h1>



  return (
    <Container>
      {event && evtTime && <div>
        <div className={"grid justify-items-start mb-5"}>
          <BackLink to={`/details/${event.group}`}><ChevronLeftIcon /> Back</BackLink>
        </div>
        <div className={"grid grid-cols-3 gap-4"}>
          <CountryWithFlag countryName={event.team1} />
          <AccentText>VS</AccentText>
          <CountryWithFlag countryName={event.team2} />
        </div>
        {event.score1 >= 0 && event.score2 >= 0 && <h2>{event.score1} : {event.score2}</h2>}

        <h2>
          <CalendarTodayIcon sx={{ color: 'secondary.main', margin: '0 5px' }} />{evtTime.toFormat('yyyy-MM-dd')}
          <AlarmIcon sx={{ color: 'secondary.main', margin: '0 5px' }} />{evtTime.toFormat('HH:mm')}
        </h2>
        <h2>{timeDiff}</h2>

        {isFuture &&
          <h3>Number of people already bet: {event.num_bets}</h3>
        }
        <hr />
        <br />
        {event && event.bets && event.bets.map(bet => {
          return <BetsList key={bet.id}>
            <User user={bet.user} />
            <h4>{bet.score1} : {bet.score2}</h4>
            <h4 className={`${bet.points === 3 && "text-yellow-500"}`}>{bet.points}pts</h4>
          </BetsList>
        })}
        <hr />
        <br />

        {isFuture ?
          <div>
            <NumberField label="Score 1" type="number"
              onChange={e => setScore1(e.target.value)}
            />
            <span style={{ color: '#ffc107', fontSize: '20px' }}>&nbsp; : &nbsp;</span>
            <NumberField label="Score 2" type="number"
              onChange={e => setScore2(e.target.value)}
            />
            <br /><br />
            <Button variant="contained" color="primary"
              onClick={() => sendBet()} disabled={!score1 || !score2}>
              Place bet
            </Button>
          </div>

          :
          event.is_admin ?
            <div>
              <NumberField label="Score 1" type="number"
                onChange={e => setScore1(e.target.value)}
              />
              <span style={{ color: '#ffc107', fontSize: '20px' }}>&nbsp; : &nbsp;</span>
              <NumberField label="Score 2" type="number"
                onChange={e => setScore2(e.target.value)}
              />
              <br /><br />
              <Button variant="contained" color="primary"
                onClick={() => setScores()} disabled={!score1 || !score2}>
                Set Scores
              </Button>
            </div> : null
        }
      </div>
      }
    </Container>


  )
}